module.exports = __webpack_public_path__ + "img/ide-func.d4d6fb8c.svg";